"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TwitterLogin_1 = require("./TwitterLogin");
exports.TwitterLogin = TwitterLogin_1.default;
exports.default = TwitterLogin_1.default;
//# sourceMappingURL=index.js.map